import React from 'react';

import { Check } from './Check';
import { DirectDeposit } from './DirectDeposit';
import { AddReimbursementMethod } from './AddReimbursementMethod';

import { REIMBURSEMENT_METHODS } from '../../../constants';

export const ReimbursementMethodCard = ({
  addressCheck = '',
  isRedirectAvailable = false,
  lastNumbers = '',
  methodType = '',
  onReimbursementMethod = () => { },
}) => {
  if (methodType === REIMBURSEMENT_METHODS.check) {
    return <Check addressCheck={addressCheck} />;
  }

  if (methodType === REIMBURSEMENT_METHODS.deposit) {
    return <DirectDeposit lastNumbers={lastNumbers} />;
  }

  // no reimbursement method set yet
  return (
    <AddReimbursementMethod
      isRedirectAvailable={isRedirectAvailable}
      onReimbursementMethod={onReimbursementMethod}
    />
  );
};
